export default __webpack_public_path__ + "static/media/Friction7Img.b2d329cd.jpg";